import { IS_DEV_ENV } from '../constants/config';

/**
 * Function wraps `console.log` to use console log safely and to have single
 * place to control all system logging (may be implemented in future).
 *
 * @param data  Any data that will be passed to `console.log`.
 */
// tslint:disable-next-line:no-any
export function log(...data: any[]) {
    if (IS_DEV_ENV) {
        // tslint:disable-next-line:no-console
        console.log(...data);
    }
}
